
<div class="plan-item">
 <div class="plan-flex">
    <img [attr.src]="'assets/img/plans/' + plan.type + '.png'" alt="">
  </div>
  <div class="plan-flex">
    <div class="plan-text">
      <div>{{plan.name | titlecase}}</div>
      ${{plan.price / 100}}
  </div>
</div>
